import {Toast} from "primereact/toast";
import React, {useEffect, useRef, useState} from "react";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {UseLoader} from "../../../hooks/useLoader";
import {error} from "../../../shared/utils/utils";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {confirmDialog} from "primereact/confirmdialog";
import {actualizarData} from "../../../api/tercero.service";


export const ModalEditarTercero= ({show, hide, fields}) => {

    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const initParams= {
        estado: "",
        nombre: "",
        tercero_id: ''
    };

    const [field, setField] = useState(initParams);

    useEffect(() => {
        setField({
            estado: fields.estado,
            tercero_id: fields.tercero_id,
            nombre: fields.nombre
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);

    const onSubmit= (e) => {
        try {
            e.preventDefault();

            if(field.estado === '' || field.nombre === '' ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await actualizarData(field);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }
                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            })

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }


    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar Compensacion" visible={show} style={{width: '70vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Editar información tercero
                            </h6>
                            <div className="row">
                            <ContainerGroupForm width="lg:w-3/12">
                                <label
                                    className="label-form"
                                    htmlFor="porcentaje"
                                >
                                    Nombre  *
                                </label>
                                <input
                                    id="nombre"
                                    type="text"
                                    className="form-input-small"
                                    value={field.nombre}
                                    required maxLength={100}
                                    onChange={(e) => setField({...field, nombre: e.target.value})}
                                />
                                {error(field.nombre, 'required')}
                                {error(field.nombre, 'maxLength', 100)}
                            </ContainerGroupForm>
                            <ContainerGroupForm width="lg:w-4/12">
                                <label
                                    className="label-form"
                                    htmlFor="estado"
                                >
                                    Estado
                                </label>
                                <select
                                    className="form-input-small"
                                    required
                                    value={field.estado}
                                    id="estado"
                                    onChange={(e) => setField({...field, estado: e.target.value})}
                                >
                                    <option value="A">Activo</option>
                                    <option value="I">Inactivo</option>
                                </select>
                            </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-3/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Actualizar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
